<template>
  <div>
    <base-header class="pb-6" type="indigo">
      <b-row align-v="center" class="py-4">
        <b-col lg="6" cols="7">
          <h6 class="h2 text-white d-inline-block mb-0">Edit Document</h6>
          <nav aria-label="breadcrumb" class="d-none d-md-inline-block ml-md-4">
            <route-bread-crumb></route-bread-crumb>
          </nav>
        </b-col>
      </b-row>
    </base-header>
    <b-container fluid class="mt--6">
      <loading
        :active.sync="loading"
        :can-cancel="false"
        :is-full-page="true"
      ></loading>

      <b-row v-if="!loading && document">
        <b-col cols="12" lg="10" xl="8" offset="0" offset-lg="1" offset-xl="2">
          <b-card>
            <b-card-header>
              <h3 class="h3 mb-0">
                Edit {{ document.shortType | humanize }} for
                {{ document.company.name | decode }}
              </h3></b-card-header
            >
            <validation-observer v-slot="{ valid, handleSubmit }">
              <b-form
                role="form"
                @submit.prevent="handleSubmit(updateDocument)"
              >
                <b-card-body>
                  <!-- Basic fields -->
                  <b-row class="border-bottom pb-3">
                    <b-col cols="12" sm="4">
                      <h4 class="display-4 uppercase">Document</h4>
                      <p class="text-muted">
                        Annual Returns for Isle of Man 1931 Act Companies
                        (limited by shares) are currently supported.
                      </p>
                    </b-col>
                    <b-col cols="12" sm="7" offset-sm="1">
                      <b-row>
                        <b-col cols="12">
                          <base-input label="Document" name="Document">
                            <select
                              class="form-control"
                              v-model="document.type"
                            >
                              <option
                                value="iom_1931_act_limited_by_shares_annual_return"
                              >
                                Annual Return for 1931 Act Company (Limited by
                                Shares)
                              </option>
                            </select>
                          </base-input>
                        </b-col>
                      </b-row>

                      <b-row>
                        <b-col cols="12" md="6">
                          <base-input
                            label="Filing Due By"
                            name="Due Date"
                            type="date"
                            v-model="document.filingDueDate"
                          ></base-input>
                        </b-col>
                      </b-row>
                    </b-col>
                  </b-row>
                  <b-row
                    class="border-bottom py-3"
                    v-if="
                      document.type ===
                        'iom_1931_act_limited_by_shares_annual_return'
                    "
                  >
                    <b-col cols="12" sm="4">
                      <h4 class="display-4 uppercase">Presentation</h4>
                      <p class="text-muted">
                        Who is signing and presenting this document?
                      </p>
                    </b-col>
                    <b-col cols="12" sm="7" offset-sm="1">
                      <b-row>
                        <b-col>
                          <find-or-create-contact-form
                            ref="findOrCreateContactForm"
                            search-label="Signatory name"
                            v-model="document.signatory.id"
                            :preset-contact="document.signatory"
                            :accountId="account.id"
                          ></find-or-create-contact-form>
                        </b-col>
                        <b-col>
                          <base-input
                            label="Signatory role"
                            name="Signatory role"
                            :rules="{ required: true }"
                            :debounce="500"
                            placeholder="e.g. Director"
                            v-model="document.details.signatoryRole"
                          ></base-input>
                        </b-col>
                      </b-row>

                      <b-row>
                        <b-col sm="6">
                          <base-input
                            label="Presenter name"
                            name="Presenter name"
                            :rules="{ required: true }"
                            :debounce="500"
                            placeholder="e.g. The Company"
                            v-model="document.details.presenterName"
                          ></base-input>
                        </b-col>

                        <b-col sm="6">
                          <base-input
                            label="Signing date"
                            name="Signing date"
                            type="date"
                            v-model="document.details.signingDate"
                          ></base-input>
                        </b-col>
                      </b-row>
                      <b-row>
                        <b-col>
                          <!-- address -->
                          <base-input
                            label="Presenter Address"
                            name="Address"
                            :rules="{ required: true }"
                            :debounce="500"
                            placeholder="e.g. 12 Marine Drive, Douglas, IM8 XE1"
                            v-model="document.details.presenterAddress"
                          ></base-input>
                        </b-col>
                      </b-row>
                    </b-col>
                  </b-row>
                  <b-row
                    class="border-bottom py-3"
                    v-if="
                      document.type ===
                        'iom_1931_act_limited_by_shares_annual_return'
                    "
                  >
                    <b-col cols="12" sm="4">
                      <h4 class="display-4 uppercase">Details</h4>
                      <p class="text-muted">
                        This information is used to complete the filing.
                      </p>
                    </b-col>
                    <b-col cols="12" sm="7" offset-sm="1">
                      <b-row>
                        <b-col sm="6">
                          <base-input
                            label="Return date"
                            name="Return date"
                            type="date"
                            v-model="document.details.returnDate"
                          ></base-input>
                        </b-col>
                      </b-row>

                      <hr />

                      <!-- Accounts prepared? -->
                      <b-row class="mb-2">
                        <b-col cols="10">
                          <label class="form-control-label align-bottom"
                            >Has the company prepared financial statements?</label
                          >
                        </b-col>
                        <b-col cols="2">
                          <base-switch
                            class="mr-1"
                            v-model="document.details.financialStatementsPrepared"
                          ></base-switch>
                        </b-col>
                      </b-row>

                      <!-- Financial statements not prepared as not required since incorporation? -->
                      <b-row class="mb-2" v-if="!document.details.financialStatementsPrepared">
                        <b-col cols="10">
                          <label class="form-control-label align-bottom">
                            The company has not been required to prepare its first set of financial
                            statements since incorporation.
                          </label>
                        </b-col>
                        <b-col cols="2" class="text-center">
                          <b-form-checkbox
                            id="financial-statements-not-required-since-incorporation"
                            v-model="document.details.financialStatementsNotRequiredSinceIncorporation"
                            name="financial-statements-not-required-since-incorporation"
                          >
                          &nbsp;
                          </b-form-checkbox>
                        </b-col>
                      </b-row>

                      <!-- Financial statements prepared until date -->
                      <b-row class="mb-2" v-if="document.details.financialStatementsPrepared">
                        <b-col cols="6">
                          <label class="form-control-label align-bottom"
                            >Financial statements prepared up to</label
                          >
                        </b-col>
                        <b-col cols="6">
                          <base-input
                            name="Financial statements prepared to date"
                            type="date"
                            v-model="document.details.financialStatementsPreparedUntil"
                          ></base-input>
                        </b-col>
                      </b-row>

                      <hr />

                      <label class="form-control-label"
                            >Accounting records</label
                          >

                      <b-row>
                        <b-col cols="4" class="text-left">
                          The company has
                        </b-col>
                        <b-col cols="8">
                          <b-form-group class="d-inline-block mb-0 ml-3 mr-0">
                            <b-form-radio class="custom-control-inline" v-model="document.details.accountingRecordsKept" name="accounting-records-kept" :value="true">kept</b-form-radio>
                            <b-form-radio class="custom-control-inline" v-model="document.details.accountingRecordsKept" name="accounting-records-kept" :value="false">not kept</b-form-radio>
                          </b-form-group>
                        </b-col>
                      </b-row>
                      <b-row>
                        <b-col cols="4" class="text-left">
                          accounting records
                        </b-col>
                        <b-col cols="8 ">
                          <b-form-group class="d-inline-block mb-0 ml-3 mr-0" v-if="document.details.accountingRecordsKept">
                            <b-form-radio class="custom-control-inline" v-model="document.details.accountingRecordsKeptSince" name="accounting-records-kept-since" :value="document.company.incorporationDate">since incorporation</b-form-radio>
                            <b-form-radio class="custom-control-inline" v-model="document.details.accountingRecordsKeptSince" name="accounting-records-kept-since" :value="document.details.financialStatementsPreparedUntil" v-if="document.details.financialStatementsPrepared">since {{ document.details.financialStatementsPreparedUntil }}</b-form-radio>
                          </b-form-group>

                          <b-form-group class="d-inline-block mb-0 ml-3 mr-0" v-if="!document.details.accountingRecordsKept">
                            <b-form-radio class="custom-control-inline" v-model="document.details.accountingRecordsNotKeptSince" name="accounting-records-kept-since" :value="document.company.incorporationDate">since incorporation</b-form-radio>
                            <b-form-radio class="custom-control-inline" v-model="document.details.accountingRecordsNotKeptSince" name="accounting-records-kept-since" :value="document.details.financialStatementsPreparedUntil" v-if="document.details.financialStatementsPrepared">since {{ document.details.financialStatementsPreparedUntil }}</b-form-radio>
                          </b-form-group>
                        </b-col>
                      </b-row>
                    </b-col>
                  </b-row>
                </b-card-body>
                <b-card-footer>
                  <b-row>
                    <b-col>
                      <b-btn @click="cancel">
                        <i class="fa fa-times mr-2"></i> Cancel
                      </b-btn>
                    </b-col>
                    <b-col class="text-right">
                      <span v-if="!valid" class="text-danger mr-4"
                        >Please complete all required fields.</span
                      >
                      <base-button native-type="submit" :disabled="!valid">
                        <span v-if="!saving">
                          Update document
                          <i class="fa fa-arrow-right ml-2"></i>
                        </span>
                        <span v-else>
                          <i class="fa fa-spin fa-spinner mr-2"></i> Please
                          wait&hellip;
                        </span>
                      </base-button>
                    </b-col>
                  </b-row>
                </b-card-footer>
              </b-form>
            </validation-observer>
          </b-card>
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>
<script>
import currencies from "currency-codes";
import _ from "underscore";
import moment from "moment";
import { get } from "dot-prop";
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";

import FindOrCreateContactForm from "../../Contacts/FindOrCreateContactForm";
import RouteBreadCrumb from "@/components/Breadcrumb/RouteBreadcrumb";

export default {
  name: "document-create",
  components: {
    FindOrCreateContactForm,
    RouteBreadCrumb,
    Loading
  },
  props: {
    companyId: {
      type: String,
      required: true
    },
    documentId: {
      type: String,
      description: "Document ID",
      required: true
    }
  },
  data() {
    return {
      document: null,
      company: null,
      errorMessage: null,
      errors: {},
      saving: false,
      loading: false
    };
  },
  computed: {
    account: function() {
      return this.$store.state.account;
    },
    signatoryId: function() {
      if (!this.document) {
        return null;
      }
      return this.document.signatory.id;
    }
  },
  mounted() {
    this.loadDocument();
  },
  watch: {
    signatoryId: function(newVal) {
      if (!this.document) {
        return null;
      }
      // check whether signatory is a director, secretary or not
      const isDirector = _.findWhere(this.document.company.directors, {
        contactId: newVal,
        isCurrent: true
      });
      const isSecretary = _.findWhere(this.document.company.secretaries, {
        contactId: newVal,
        isCurrent: true
      });

      if (isDirector) {
        this.document.details.signatoryRole = "Director";
      } else if (isSecretary) {
        this.document.details.signatoryRole = "Secretary";
      } else {
        this.document.details.signatoryRole = "Authorized Signatory";
      }
    }
  },
  methods: {
    loadDocument() {
      this.loading = true;
      this.axios
        .get(
          `/v1/accounts/${this.account.id}/companies/${this.companyId}/documents/${this.documentId}?expand=company`
        )
        .then(response => {
          this.loading = false;
          this.document = response.data;
          s;
        })
        .catch(error => {
          this.loading = false;
          this.errorMessage = "Failed to load document";
          if (get(error, "response.data.message")) {
            this.errorMessage = error.response.data.message;
          }
        });
    },
    cancel() {
      // go to document view page
      this.$router.push(
        `/companies/${this.document.company.id}/documents/${this.document.id}`
      );
    },
    updateDocument: function() {
      const requestBody = {};

      requestBody.type = this.document.type;
      requestBody.filingDueDate = this.document.filingDueDate;
      requestBody.signatoryId = this.document.signatoryId;

      if (
        this.document.type === "iom_1931_act_limited_by_shares_annual_return"
      ) {
        requestBody.details = {};
        requestBody.details.signatoryRole = this.document.details.signatoryRole;
        requestBody.details.returnDate = this.document.details.returnDate;
        requestBody.details.signingDate = this.document.details.signingDate;
        requestBody.details.presenterName = this.document.details.presenterName;
        requestBody.details.presenterAddress = this.document.details.presenterAddress;

        // financial statements
        requestBody.details.financialStatementsPrepared = this.document.details.financialStatementsPrepared;
        if (this.document.details.financialStatementsPrepared) {
          requestBody.details.financialStatementsPreparedUntil = this.document.details.financialStatementsPreparedUntil;
        } else {
          requestBody.details.financialStatementsNotRequiredSinceIncorporation = this.document.details.financialStatementsNotRequiredSinceIncorporation;
        }

        // accounting records
        requestBody.details.accountingRecordsKept = this.document.details.accountingRecordsKept;
        if (this.document.details.accountingRecordsKept) {
          requestBody.details.accountingRecordsKeptSince = this.document.details.accountingRecordsKeptSince;
        } else {
          requestBody.details.accountingRecordsNotKeptSince = this.document.details.accountingRecordsNotKeptSince;
        }
      }

      // send the request
      this.saving = true;
      this.axios
        .patch(
          `/v1/accounts/${this.account.id}/companies/${this.companyId}/documents/${this.documentId}`,
          requestBody
        )
        .then(response => {
          this.saving = false;
          // notify
          this.$notify({
            message: "Document updated",
            timeout: 3000,
            icon: "fa fa-check",
            type: "success"
          });

          // go to document view page
          this.$router.push(
            `/companies/${this.companyId}/documents/${this.documentId}`
          );
        })
        .catch(error => {
          this.saving = false;
          this.errorMessage = "Failed to update document";
          if (get(error, "response.data.message")) {
            this.errorMessage = error.response.data.message;
          }
        });
    }
  }
};
</script>
<style>
.starter-page {
  min-height: calc(100vh - 380px);
}
</style>
